export const top20Filters = {
  '3000015284': [{ filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' }],
  '3000016152': [
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
  ],
  '3000003349': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
    { filterType: 'amenities', code: 'SPOOL', name: 'Swimming Pool' },
  ],
  '3000061781': [
    { filterType: 'amenities', code: 'INCLUSIVE', name: 'All Inclusive' },
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'ADULTONLY', name: 'Adults Only' },
  ],
  '3000003311': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'propertyTypes', code: 'HTLS', name: 'Hotels' },
  ],
  '3000003192': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'amenities', code: 'AIRSHUTTL', name: 'Airport Shuttle' },
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
  ],
  '3000004031': [
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
  ],
  '5000494493': [
    { filterType: 'amenities', code: 'INCLUSIVE', name: 'All Inclusive' },
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'ADULTONLY', name: 'Adults Only' },
  ],
  '3000003496': [
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
  ],
  '3000001947': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
  ],
  '3000033452': [
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'propertyTypes', code: 'HTLS', name: 'Hotels' },
  ],
  '3000024950': [
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'amenities', code: 'BCHFRNT', name: 'Waterfront' },
    { filterType: 'amenities', code: 'SPOOL', name: 'Swimming Pool' },
  ],
  '3000005381': [
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
  ],
  '3000021312': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
  ],
  '3000040035': [
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
  ],
  '3000060600': [
    { filterType: 'amenities', code: 'INCLUSIVE', name: 'All Inclusive' },
    { filterType: 'hotelStarLevel', code: '4', name: '4+ Star Rating' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'BCHFRNT', name: 'Waterfront' },
  ],
  '3000021082': [
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
  ],
  '3000003431': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'propertyTypes', code: 'HTLS', name: 'Hotel' },
  ],
  '3000001349': [
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
    { filterType: 'guestRating', code: '8', name: '8+ Guest Rating' },
  ],
  '3000020633': [
    { filterType: 'amenities', code: 'FBRKFST', name: 'Free Breakfast' },
    { filterType: 'hotelStarLevel', code: '3', name: '3+ Star Rating' },
    { filterType: 'amenities', code: 'FPRKING', name: 'Free Parking' },
  ],
} as const
